import styled from '@emotion/styled';

const MainContainer = styled.main`
    flex-grow: 1;
    position: relative;
`;

export { MainContainer };
